// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Mfonl","footnote":"styles_footnote__+q2MM","grayText":"styles_grayText__Mx4xv","tableWrapper":"styles_tableWrapper__GGlYG"};